module.exports = __webpack_public_path__ + "img/google-g-logo.0b1acf16.svg";